import { applicationFieldLabels, fieldLabels } from "../fieldLabels";
import { Activity } from "@ofqual/portal-activity-feed";

export type FieldChange = {
  field: keyof typeof fieldLabels;
  oldValue: string | null;
  newValue: string | null;
};

export type ActivityBody = {
  id: string;
  changes: FieldChange[];
};

export type ApplictionFieldChange = {
  field: keyof typeof applicationFieldLabels;
  oldValue: string | null;
  newValue: string | null;
};

export type ApplicationActivityBody = {
  id: string;
  changes: ApplictionFieldChange[];
};

export interface AttachmentBodyProps extends ActivityBody {
  documents: {
    blobId: string;
    fileName: string;
    contentType: string;
  }[];
}

export type ActivityDialogProps = {
  activity: Activity;
  onClose: () => void;
};

export enum DialogType {
  Approval,
  AddEvent,
  SendMessage,
  AddAttachment,
  ActivityAction,
}

export interface EntityDialog {
  dialogType: DialogType;
  focussedActivity?: Activity;
}
